(function () {

  function move() {
    var kb = document.querySelector('kaching-bundle');
    var progress = document.querySelector('.le-hero__progress');
    var delivery = document.querySelector('.le-hero__delivery');
    var atcRow = document.querySelector('.le-hero__atc-row');

    if (!kb || !progress) return false;

    progress.parentNode.insertBefore(kb, progress.nextSibling);

    if (delivery && atcRow) {
      atcRow.parentNode.insertBefore(delivery, atcRow);
    } else if (delivery) {
      kb.parentNode.insertBefore(delivery, kb.nextSibling);
    }

    return true;
  }

  if (!move()) {
    var n = 0;

    var iv = setInterval(function () {
      if (move() || ++n > 20) clearInterval(iv);
    }, 300);
  }

})();


(function () {

  function applyPriceSize() {
    document.querySelectorAll(
      '.kaching-bundles__bar:nth-child(2) .kaching-bundles__bar-full-price, ' +
      '.kaching-bundles__bar:nth-child(3) .kaching-bundles__bar-full-price, ' +
      '.kaching-bundles__bar:nth-child(2) .kaching-bundles__bar-full-price .money.buckscc-money, ' +
      '.kaching-bundles__bar:nth-child(3) .kaching-bundles__bar-full-price .money.buckscc-money'
    ).forEach(function (el) {
      el.style.setProperty('font-size', '14px', 'important');
    });
  }

  applyPriceSize();

  var observer = new MutationObserver(function () {
    applyPriceSize();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();